import React from 'react';

import styles from './dueDiligenceStyles';

import DocumentList from 'buyside/components/presentation/DocumentList/documentList';
import Link from 'buyside/components/presentation/Link/link';

import UserIcon from 'buyside/svgs/user_icon.svg';
import EnvelopeIcon from 'buyside/svgs/envelope.svg';
import PhoneIcon from 'buyside/svgs/phone.svg';

import { dueDiligenceDocumentUrl } from 'buyside/util/urlHelper';

const DueDiligence = ({ fundProfile, createAuditRecord }) => {
  const { dueDiligenceDocuments, serviceProviders } = fundProfile;
  return (
    <div>
      {!!dueDiligenceDocuments.length && (
        <div className={styles.dueDiligenceSection}>
          <h4>Documents</h4>
          <DocumentList documents={dueDiligenceDocuments} urlFn={dueDiligenceDocumentUrl} />
        </div>
      )}
      {!!serviceProviders.length && (
        <div className={styles.dueDiligenceSection}>
          <h4>Service Providers</h4>
          <ul className={styles.serviceProvidersList}>
            {serviceProviders.map((serviceProvider, idx) => (
              <div key={idx} className={styles.serviceProvider}>
                <div>
                  <strong>{serviceProvider.category}</strong> – {serviceProvider.firmName}
                </div>
                <div className={styles.serviceProviderContactInfo}>
                  <span>
                    <UserIcon />
                    <span>{serviceProvider.contactName}</span>
                  </span>
                  <span>
                    <EnvelopeIcon />
                    <Link
                      to={`mailto:${serviceProvider.contactEmail}`}
                      onMouseDown={() =>
                        createAuditRecord(
                          serviceProvider.id,
                          'EmployerProfileServiceProvider',
                          'mailto_click'
                        )
                      }
                    >
                      {serviceProvider.contactEmail}
                    </Link>
                  </span>
                  <span>
                    <PhoneIcon />
                    <span>{serviceProvider.contactPhoneNumber}</span>
                  </span>
                </div>
              </div>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DueDiligence;
